@use '../../design-tokens/typography/typography' as *;
@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .root {
    @include border-radius-r1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    white-space: nowrap;
    border: none;
    background-color: transparent;
    color: var(--text-primary);
    padding: 0;

    &:hover {
      text-decoration: underline;
    }

    &:focus {
      outline: 1px solid var(--border-focus);
      text-decoration: underline;
    }

    &:disabled {
      text-decoration: none;
      cursor: default;
      color: var(--text-disabled);

      svg {
        fill: var(--icon-disabled);
      }
    }

    svg {
      fill: var(--icon-primary);
    }
  }

  .label {
    @include typography-v2-ui-sm;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .labelReversed {
    flex-direction: row-reverse;
  }
}
